export function ApplicationFormHeader() {
  return (
    <>
      <div className="mb-5 flex items-start justify-center animate-fade-in-up">
        <h1 className="modal-heading__title text-center">
          Apply for Commercial Driver License (CDL) Training
        </h1>
      </div>
      <div className="border-t border-gray-lighter animate-[expand-x_0.5s_ease-out_0.1s_both]" />
    </>
  )
}
